<template>
  <div class='oversea'>
    <div v-if="isPC">
      <div><img src="/static/images/activty/promotions/kraddress/kraddress_01.jpg"></div>
      <div><img src="/static/images/activty/promotions/kraddress/kraddress_02.jpg"></div>
      <div><img src="/static/images/activty/promotions/kraddress/kraddress_03.jpg"></div>
      <div><img src="/static/images/activty/promotions/kraddress/kraddress_04.jpg"></div>
      <div class="btn"><img src="/static/images/activty/promotions/kraddress/kraddress_05.jpg"><span @click="goto()"></span><span class="one" @click="goto()"></span></div>
      <div><img src="/static/images/activty/promotions/kraddress/kraddress_06.jpg"></div>
      <div><img src="/static/images/activty/promotions/kraddress/kraddress_07.jpg"></div>
    </div>
    <div v-if="!isPC">
      <div><img src="/static/images/activty/promotions/kraddress/appkraddress_01.jpg"></div>
      <div><img src="/static/images/activty/promotions/kraddress/appkraddress_02.jpg"></div>
      <div><img src="/static/images/activty/promotions/kraddress/appkraddress_03.jpg"></div>
      <div><img src="/static/images/activty/promotions/kraddress/appkraddress_04.jpg"></div>
      <div><img src="/static/images/activty/promotions/kraddress/appkraddress_05.jpg"></div>
      <div class="btn app"><img src="/static/images/activty/promotions/kraddress/appkraddress_06.jpg"><span @click="appGoto()"></span></div>
      <div><img src="/static/images/activty/promotions/kraddress/appkraddress_07.jpg"></div>
      <div class="btn app"><img src="/static/images/activty/promotions/kraddress/appkraddress_08.jpg"><span @click="appGoto()"></span></div>
      <div><img src="/static/images/activty/promotions/kraddress/appkraddress_09.jpg"></div>
      <div><img src="/static/images/activty/promotions/kraddress/appkraddress_10.jpg"></div>
      <div><img src="/static/images/activty/promotions/kraddress/appkraddress_11.jpg"></div>
      <div><img src="/static/images/activty/promotions/kraddress/appkraddress_12.jpg"></div>
      <div><img src="/static/images/activty/promotions/kraddress/appkraddress_13.jpg"></div>
    </div>
  </div>
</template>
<script>
import { getInfo } from "@/api/public";
export default {
  name: '',
  components: {},
  data() {
    return {}
  },
  props: {
    data: {},
    isPC: Boolean,
  },
  watch: {},
  mounted() {},
  created() {},
  methods: {
    goto() {
      let that = this
      let userInfo = getInfo()
      if (userInfo) {
        that.$router.push({
          path: '/mycardhobby/setting'
        })
      } else {
        that.$router.push({
          path: '/login'
        })
      }
    },
    appGoto() {
      let that = this
      let ua = navigator.userAgent.toLowerCase();
      console.log('ua', ua)
      //android终端
      let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1 || ua.indexOf('android') > -1 || ua.indexOf('adr') > -1;
      console.log('isAndroid', isAndroid)
      //ios终端
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

      let data = that.data
      if (!isAndroid) {
        //ios
        console.log(" 我是ios")
        //这里是和IOS商量好的写法，调用IOS的finishActivity方法
        try {
          window.webkit.messageHandlers.GetActivityDetail.postMessage(data)
        } catch (error) {
          console.log('WKWebView post message');
        }
      } else if (isAndroid) {
        //android
        console.log("我是android", JSON.stringify(data));
        //这里是和安卓商量好的写法，调用安卓的finishActivity方法
        //android.PayCallback('我是android测试传值');           
        android.GetActivityDetail(JSON.stringify(data));
      }
    }
  },
}

</script>
<style scoped>
.oversea img {
  width: 100%;
  display: block;
  overflow: hidden;
}

.oversea .btn {
  position: relative;
}

.oversea .btn>span {
  position: absolute;
  width: 20vw;
  height: 100%;
  top: 0;
  right: 42vw;
  cursor: pointer;
}

.oversea .btn>span.one {
  right: auto;
  left: 7vw;
}

.oversea .app>span {
  position: absolute;
  width: 24vw;
  height: 100%;
  top: 0;
  right: 79px;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/activity/promotions/kraddress.vue